import { Typography } from '@mui/material';
import styles from 'features/DefaultHelp.module.css';

const OverviewSection = () => {
    return (
        <>
            <Typography variant="h4">OVERVIEW</Typography>
            <Typography classes={styles['description']} align="justify">
                This page allows users to communicate with the Birdseye Customer Support (CS) team by submitting and tracking support requests. You
                can report issues, ask for technical support, or request new features/enhancements. Each ticket includes a status, message thread, and
                activity history to ensure transparency and resolution tracking.
            </Typography>
        </>
    );
};

export default OverviewSection;
